const words = ["Webdesign Augsburg", "Websites", "Entwicklung", "Branding", "Performance", "Erlebnisse"];

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative z-10 overflow-hidden border-y border-[#D4AF37]/10 bg-[#050505]/40 py-8 md:py-12"
    >
      <div className="flex w-max animate-[marquee_48s_linear_infinite]">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center">
            {words.map((w) => (
              <span key={copy + w} className="flex items-center">
                <span className="text-stroke-gold whitespace-nowrap px-8 font-serif-accent text-5xl italic md:px-12 md:text-7xl">
                  {w}
                </span>
                <span className="h-1.5 w-1.5 rounded-full bg-[#D4AF37]/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
